angular
  .module("avant.customer_applications.directives")
  .directive "amountClearIrrelevantData", [
    'ValidationsRequiredHelper',
    (ValidationsRequiredHelper) ->
      restrict: "A"
      require: "ngModel"
      link: (scope, _element, attributes, ngModelCtrl) ->

        modelName = ngModelCtrl.$name

        # Unset the view value and angular model value of the field
        # without running the parser or change listener callbacks.
        #
        # This prevents additional calls to validations, save_fields, watchers, etc.
        clearField = ->
          parsers = ngModelCtrl.$parsers
          listeners = ngModelCtrl.$viewChangeListeners
          try
            ngModelCtrl.$parsers = []
            ngModelCtrl.$viewChangeListeners = []
            ngModelCtrl.$setViewValue(null)
          finally
            ngModelCtrl.$parsers = parsers
            ngModelCtrl.$viewChangeListeners = listeners

        clearIrrelevantData = (requirementsConfig) ->
          return unless fieldConditionallyRequired(requirementsConfig)
          return unless shouldClear()
          clearField()
          ngModelCtrl.$render()

        fieldConditionallyRequired = (requirementsConfig) ->
          requirementsConfig.required.indexOf("conditionally_required") != -1

        shouldClear = ->
          ValidationsRequiredHelper.readFromDictionary(modelName) == false

        # runs on submit, will not run if there are client side errors
        scope.$on('customer_application:presubmit:cleanup', (event) ->
          model = attributes.amountClearIrrelevantData || attributes.ngModel
          requirementsConfig = scope.requirements[model]
          clearIrrelevantData(requirementsConfig)
        )
  ]
